import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Activation from './views/Activation.vue'
//import Record from './views/Record.vue'
import Visualization from './views/Visualization.vue'
import InfoGraphics from './views/InfoGraphics.vue'
import Help from './views/Help.vue'
import UserProfile from './views/UserProfile.vue'
import SavedSearches from './views/SavedSearches.vue'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      props: (route) => ({ query: route.query.q })
    },
    { path: '/detail/:id',
      component: Home,
      props: true
    },
/*
    { path: '/record/:id',
      name: 'record',
      component: Record,
      props: true
    },
*/
    {
      path: '/infographics',
      name: 'infographics',
      component: InfoGraphics,
      props: true
    },
    {
      path: '/visualization',
      name: 'visualization',
      component: Visualization,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/profile',
      name: 'profile',
      component: UserProfile
    },
    {
      path: '/savedsearches',
      name: 'savedsearches',
      component: SavedSearches
    },
    {
      path: '/activation',
      name: 'activation',
      component: Activation
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    // otherwise redirect to home
    { path: '*', redirect: '/', props: (route) => ({ query: route.query.q }) }
  ]
});


router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login','/activation', '/help'];
  const authRequired = !publicPages.includes(to.path);
  const authenticated = localStorage.getItem('authToken');


  if (authRequired && !authenticated) {

    next({
       path: '/login',
       query: { redirect: to.fullPath },
       replace: true
     });

  } else {
    next();
  }

})

export default router;
